import { AppTable } from './app-table';
import { createAsyncSelectors } from '@lib/selectors';
import { FeatureBoundary } from '@ui/features';
import React from 'react';
import { SonarCard } from '@ui/general';
import { Space } from 'antd';
import { CHANGE_EVENT_PREFERENCES, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ChangeEvents, DisableDataSecurityButton } from './change-events';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import { useAction, useAsyncState, useOnMount } from '@hooks';
const dataSecurityStatusSelectors = createAsyncSelectors((state) => state.core.dataSecurity.status.get);
export const IntegratedApps = () => {
    const { data, isRequested } = useAsyncState(dataSecurityStatusSelectors);
    const loadDataSecurityStatus = useAction(coreActions.requestGetCoreDataSecurityStatus);
    useOnMount(() => {
        loadDataSecurityStatus();
    });
    return (React.createElement(Space, { direction: 'vertical' },
        React.createElement(FeatureBoundary, { feature: FeatureFlag.DataSecurityDashboard },
            React.createElement(SonarCard, { extra: React.createElement(DisableDataSecurityButton, { isEnabled: data }), title: CHANGE_EVENT_PREFERENCES.SELECTED_OBJECTS },
                React.createElement(ChangeEvents, { isEnabled: data, isLoading: isRequested }))),
        React.createElement(SonarCard, { title: COPY_SPECIFIC.INTEGRATED_APPS, noSpacingX: true },
            React.createElement(AppTable, null))));
};
